import api from '@/api/reports';

const actions = {
  FETCH_COURSES_REPORT: async ({ commit, dispatch, state, rootGetters }) => {
    const { organizationId } = rootGetters;

    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;

    const offset = currentPage * pageSize;

    const params = {
      organization_id: organizationId,
      limit: pageSize,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    dispatch('wait/start', 'coursesReport.fetching', { root: true });

    try {
      const { count, results: report } = await api.fetchCoursesReport(params);

      commit('SET_REPORT', report);
      commit('SET_COUNT', count);

      return report;
    } finally {
      dispatch('wait/end', 'coursesReport.fetching', { root: true });
    }
  },

  DOWNLOAD_COURSES: async ({ state, rootGetters }, { formatType }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const fields = state.columns.filter(x => x.showColumn).map(x => x.source_field);

    await api.fetchCoursesReport({
      organization_id: organizationId,
      pageSize,
      currentPage,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
      format: formatType,
      include: fields,
    });
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, dateRange) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', { currentPage: 0 });
    dispatch('FETCH_COURSES_REPORT');
  },
};

export default actions;
